module.exports = (Promise.resolve(__parcel__require__("./" + "Doppio.f1515d2a.64828b84.js"))).then(() => parcelRequire('6QYtj'));